<div class="card">
  <form [formGroup]="eventGroup">
    <sib-grid name="eventGrid" #sibGrid [buttons]="buttonConfig" [totalRecord]="totalRecords" 
       [columns]="columns" [config]="gridConfig" formControlName="gridControl"
      ngDefaultControl>
    </sib-grid>
  </form>

</div>